import React from 'react';

const Toggle = ({ onChange, checked }) => {
  return (
    <label className='relative inline-flex items-center cursor-pointer'>
      <input type='checkbox' value='' checked={checked} className='sr-only peer' onChange={onChange} />
      <div
        className="w-11 h-6 bg-neutral-silver-400 peer-focus:outline-none peer-focus:ring-4 
        peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full
        peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px]
        after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5
        after:w-5 after:transition-all  peer-checked:bg-brand-uva"
      ></div>
    </label>
  );
};

export default Toggle;
